const welcomeMessageDescription = {
  displayField: null,
  name: 'Welcome Message Description',
  description: '',
  fields: [
    {
      id: 'description',
      name: 'description',
      type: 'RichText',
      localized: true,
      required: true,
      validations: [
        {
          enabledMarks: [
            'bold',
            'italic',
            'underline',
            'code',
            'superscript',
            'subscript'
          ],
          message: 'Only bold, italic, underline, code, superscript, and subscript marks are allowed'
        },
        {
          enabledNodeTypes: [
            'heading-1',
            'heading-2',
            'heading-3',
            'heading-4',
            'heading-5',
            'heading-6',
            'ordered-list',
            'unordered-list',
            'hr',
            'blockquote',
            'embedded-entry-block',
            'embedded-asset-block',
            'table',
            'hyperlink',
            'entry-hyperlink',
            'asset-hyperlink',
            'embedded-entry-inline'
          ],
          message: 'Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, asset, table, link to Url, link to entry, link to asset, and inline entry nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'welcomeMessageDescription',
    version: 6,
    updatedAt: '2023-08-02T22:14:42.061Z'
  }
};
export default welcomeMessageDescription;